import api from '../api/residential'
import apiDirectors from '../api/directors'
import apiNews from '../api/news'
import apiImi from '../api/imi'
import apiProperties from '../api/properties'

export const actionTypes = {
	RECEIVE_DIRECTORS: 'residential/RECEIVE_DIRECTORS',
  RECEIVE_NEWS: 'residential/RECEIVE_NEWS',
  RECEIVE_IMIS: 'residential/RECEIVE_IMIS',
  RECEIVE_RESIDENTIAL_TYPES: 'residential/RECEIVE_RESIDENTIAL_TYPES',
  RECEIVE_UBICATIONS: 'residential/RECEIVE_UBICATIONS',
  CHANGE_CHECK_VALUE: 'residential/CHANGE_CHECK_VALUE',
  SET_PROFESSIONAL_USE: 'residential/SET_PROFESSIONAL_USE',
  RECEIVE_UNIT_STATE: 'residential/RECEIVE_UNIT_STATE',
  SET_NEW: 'residential/SET_NEW'
}

export const residentialsTypes = () => {
  return(dispatch) => {
    apiProperties.loadResidentialsTypes()
      .then((data) => dispatch(receiveResidentialTypes(data)))
  }
}

function receiveResidentialTypes(APIdata) {
  return {
    type: actionTypes.RECEIVE_RESIDENTIAL_TYPES,
    data: APIdata
  }
}

export const loadDirectorsBySector = (id) => {
  return(dispatch, getStore) => {
    apiDirectors.fetchDirectorsBySector(id)
      .then((data) => dispatch(receiveDirectors(data)))
  }
}

function receiveDirectors(APIdata) {
  return {
    type: actionTypes.RECEIVE_DIRECTORS,
    data: APIdata.data
  }
}

export const loadNewsBySector = (id) => {
  return(dispatch, getStore) => {
    apiNews.fetchNewsBySector(id)
      .then((data) => dispatch(receiveNews(data)))
  }
}

function receiveNews(APIdata) {
  return {
    type: actionTypes.RECEIVE_NEWS,
    data: APIdata
  }
}

export const loadImisBySector = (id) => {
  return(dispatch, getStore) => {
    apiImi.fetchImisBySector(id)
      .then((data) => dispatch(receiveImis(data)))
  }
}

function receiveImis(APIdata) {
  return {
    type: actionTypes.RECEIVE_IMIS,
    data: APIdata.data
  }
}

export const retriveUbications = () => {
  return(dispatch, getStore) => {
    api.fetchUbications()
      .then((data) => dispatch(receiveUbications(data)))
  }
}

function receiveUbications(APIdata) {
  return {
    type: actionTypes.RECEIVE_UBICATIONS,
    data: APIdata
  }
}

export const retriveUnitState = () => {
  return(dispatch, getStore) => {
    api.fetchUnitState()
      .then((data) => dispatch(receiveUnitState(data)))
  }
}

function receiveUnitState(APIdata) {
  return {
    type: actionTypes.RECEIVE_UNIT_STATE,
    data: APIdata
  }
}

export const changeCheckValue = (value) => {
  if (value === 'is_prof'){
    return {
      type: actionTypes.SET_PROFESSIONAL_USE
    }
  }
  else {
    return {
      type: actionTypes.SET_NEW
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/residential.js